import React from "react";
import Header from "./header";
import Sidebar from "./sidebar";
import { Outlet } from "react-router-dom";

/**
 * Callback function to toggle the menu layout based on the screen width.
 * @returns None
 */
function Layout(props) {
  /**
   * Toggles the menu based on the screen width.
   * If the screen width is less than or equal to 998 pixels, it toggles the "sidebar-enable" class on the body element.
   * If the screen width is greater than 998 pixels, it toggles the "vertical-collapsed" and "sidebar-enable" classes on the body element.
   * @returns None
   */
  const toggleMenuCallback = () => {
    var body = document.body;


    if (window.screen.width <= 1024) {
      body.classList.toggle("sidebar-enable");
      body.classList.toggle("vertical-collpsed");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  };


  return (
    /**
     * Renders the main layout of the application.
     * @returns {React.Element} - The JSX element representing the main layout.
     */
    <React.Fragment>
      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />
        <Sidebar />
        <div className="main-content">
          <Outlet />
        </div>
      </div>
    </React.Fragment>
  );
}

export default Layout;
